export enum EPageMetric {
  PAGE_ITEMS = 'page_items',
  PAGE_PATHS = 'page_paths',
}

export enum EPageDimension {
  PAGE_PATH = 'page_path',
}

export enum EPageField {
  SHOPIFY_PAGE_ID = 'shopify_page_id',
  LOCATION_PATH = 'location_path',
  PAGE_TYPE = 'page_type',
  PAGE_TITLE = 'page_title',
  PAGE_PATH = 'page_path',
  TEMPLATE_SUFFIX = 'template_suffix',
}

export interface IPageItemsPayload {
  [EPageField.SHOPIFY_PAGE_ID]: string;
  [EPageField.LOCATION_PATH]: string;
  [EPageField.PAGE_TYPE]: string;
  [EPageField.PAGE_TITLE]: string;
  [EPageField.TEMPLATE_SUFFIX]: string;
}
